import { createContextAwareHook } from './useContextAwareHook';
import {
  useGetPackagingQuery,
  usePublicGetPackagingQuery,
  useGetPackagingEntriesQuery,
  usePublicGetPackagingEntriesQuery,
  useGetPackagingEntriesDefaultsQuery,
  usePublicGetPackagingEntriesDefaultsQuery,
  useUpdatePackagingsMutation,
  useCreatePackagingEntryMutation,
  useUpdatePackagingEntryMutation,
  useDeletePackagingEntryMutation
} from '../features/modules/packagingApiSlice';

/**
 * Returns a hook that automatically selects between public and private APIs
 * for getting packaging data based on the current route.
 */
export const useContextAwareGetPackaging = createContextAwareHook(
  useGetPackagingQuery,
  usePublicGetPackagingQuery
);

/**
 * Returns a hook that automatically selects between public and private APIs
 * for getting packaging entries based on the current route.
 */
export const useContextAwareGetPackagingEntries = createContextAwareHook(
  useGetPackagingEntriesQuery,
  usePublicGetPackagingEntriesQuery
);

/**
 * Returns a hook that automatically selects between public and private APIs
 * for getting packaging entries defaults based on the current route.
 */
export const useContextAwareGetPackagingEntriesDefaults = createContextAwareHook(
  useGetPackagingEntriesDefaultsQuery,
  usePublicGetPackagingEntriesDefaultsQuery
);

// Export mutation hooks directly
export {
  useUpdatePackagingsMutation,
  useCreatePackagingEntryMutation,
  useUpdatePackagingEntryMutation,
  useDeletePackagingEntryMutation
}; 